import { Component, ComponentType } from 'react'
import * as debounce from 'lodash/debounce'

type DeferredState = {
  isReady: boolean
}

// HOC for deferred rendering
// for example it's useful when you have many forms with same identifier
// and one can mount just before previous has destroyed
function Deferred<TProps extends {}> (InnerComponent: ComponentType<TProps>, time?: number) {
  return class extends Component<TProps, DeferredState> {
    state = {
      isReady: false,
    }

    render () {
      const { isReady } = this.state

      return isReady ? (
        <InnerComponent { ...this.props } />
      ) : null
    }

    componentDidMount () {
      time === undefined ?
        this.setState({ isReady: true }) :
        this.showComponent()
    }

    componentWillUnmount () {
      this.showComponent.cancel()
    }

    private showComponent = debounce(() => {
      this.setState({ isReady: true })
    }, time)
  }
}

export default Deferred
